<template>

    <main class="">

        <section class="py-5 text-bg-secondary">

            <div class="container">
                <h1 class="display-1">DENTAGEN Provisionen</h1>
            </div>

        </section>

        <section class="py-5 bg-light">

            <div class="container">
                <div class="row row-cols-lg-3 g-4">
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Umsatz gesamt</h5>
                                <p class="display-4">12.200,99 €</p>
                                <a href="#" class="btn btn-primary">Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Anzahl Bestellungen</h5>
                                <p class="display-4">98</p>
                                <a href="#" class="btn btn-primary">Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Provision gesamt</h5>
                                <p class="display-4">4.000,80 €</p>
                                <a href="#" class="btn btn-primary">Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Provision unbestätigt</h5>
                                <p class="display-6">1.000,40 €</p>
                                <a href="#" class="btn btn-primary">Details</a>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">Provision ausgezahlt</h5>
                                <p class="display-6">3.000,40 €</p>
                                <a href="#" class="btn btn-primary">Details</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>

        <section>
            <div id="chart_div" style="width: 100%; height: 500px;"></div>
        </section>

        <section class="py-5">

            <div class="container">

                <h4>Provisionen pro Bestellung</h4>

                <table class="table">
                    <thead>
                        <tr>
                            <th>Kunde</th>
                            <th>Umsatz</th>
                            <th>Datum Bestellung</th>
                            <th>Provision</th>
                            <th>Verkäufer</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Zahnarztpraxis Schmidt</td>
                            <td>1.500,00 €</td>
                            <td>12.02.2023</td>
                            <td>30,00 €</td>
                            <td>Dental Bauer</td>
                        </tr>
                        <tr>
                            <td>Praxis Meier</td>
                            <td>300,00 €</td>
                            <td>10.02.2023</td>
                            <td>6,00 €</td>
                            <td>Cherrymed</td>
                        </tr>
                        <tr>
                            <td>Zahnarzt Schulte</td>
                            <td>500,00 €</td>
                            <td>09.02.2023</td>
                            <td>20,00 €</td>
                            <td>Cherrymed</td>
                        </tr>
                        <tr>
                            <td>Zahnarzt Stepke</td>
                            <td>1200,00 €</td>
                            <td>09.02.2023</td>
                            <td>25,00 €</td>
                            <td>Dental Bauer</td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </section>

        <section class="py-5">

            <div class="container">

                <h4>Zusammenfassung</h4>

                <table class="table table">
                    <thead>
                        <tr style="text-align: center;">
                            <th style="text-align: left;">Zeitraum</th>
                            <th>Views</th>
                            <th>Klicks</th>
                            <th>CTR</th>
                            <th>Sales</th>
                            <th>Leads</th>
                            <th>Umsatz</th>
                            <th>eEPM</th>
                            <th>eEPC</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="text-align: center;">
                            <td style="text-align: left;">
                                <a href="/program/0-0/2023-03-02/2023-03-02">
                                    Heute            </a>
                            </td>

                            <td>47.189</td>
                            <td>635</td>
                            <td>1,35 %</td>
                            <td>77</td>
                            <td>83</td>
                            <td>218,29 €</td>
                            <td>4,63 €</td>
                            <td>0,34 €</td>
                        </tr>
                        <tr style="text-align: center;">
                            <td style="text-align: left;">
                                <a href="/program/0-0/2023-03-01/2023-03-01">
                                    Gestern            </a>
                            </td>

                            <td>48.314</td>
                            <td>470</td>
                            <td>0,97 %</td>
                            <td>58</td>
                            <td>58</td>
                            <td>359,81 €</td>
                            <td>7,45 €</td>
                            <td>0,77 €</td>
                        </tr>
                        <tr style="text-align: center;">
                            <td style="text-align: left;">
                                <a href="/program/0-0/2023-03-01/2023-03-02">
                                    Aktueller Monat            </a>
                            </td>

                            <td>95.503</td>
                            <td>1.105</td>
                            <td>1,16 %</td>
                            <td>135</td>
                            <td>141</td>
                            <td>578,10 €</td>
                            <td>6,05 €</td>
                            <td>0,52 €</td>
                        </tr>
                        <tr style="text-align: center;">
                            <td style="text-align: left;">
                                <a href="/program/0-0/2023-02-01/2023-02-28">
                                    Letzter Monat            </a>
                            </td>

                            <td>1.255.383</td>
                            <td>20.618</td>
                            <td>1,64 %</td>
                            <td>1.908</td>
                            <td>1.927</td>
                            <td>8.063,63 €</td>
                            <td>6,42 €</td>
                            <td>0,39 €</td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </section>

        <section class="py-5">

            <div class="container">

                <h4>Tagesaktivität</h4>

                <table class="table" id="network-daily-activity">
                    <thead>
                        <tr class="tophead" role="row"><td rowspan="1" colspan="1"></td><td colspan="3" rowspan="1">Aktivität</td><td colspan="3" rowspan="1">Sales</td><td colspan="1" rowspan="1">Leads</td><td colspan="3" rowspan="1">Umsatz</td></tr>
                        <tr class="head" role="row"><th class="sorting_desc" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="Datum: activate to sort column ascending">Datum</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="Views: activate to sort column ascending">Views</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="Klicks: activate to sort column ascending">Klicks</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="CTR: activate to sort column ascending">CTR</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="Offen: activate to sort column ascending">Offen</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="Bestätigt: activate to sort column ascending">Bestätigt</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="Total: activate to sort column ascending">Total</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="Total: activate to sort column ascending">Total</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="Total: activate to sort column ascending">Total</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="eEPM: activate to sort column ascending">eEPM</th><th class="sorting" role="columnheader" tabindex="0" aria-controls="network-daily-activity" rowspan="1" colspan="1" aria-label="eEPC: activate to sort column ascending">eEPC</th></tr>
                    </thead>

                    <tfoot>
                        <tr><td rowspan="1" colspan="1">Gesamt</td><td rowspan="1" colspan="1">95.503</td><td rowspan="1" colspan="1">1.105</td><td rowspan="1" colspan="1">1,16 %</td><td rowspan="1" colspan="1">50</td><td rowspan="1" colspan="1">85</td><td rowspan="1" colspan="1">195</td><td rowspan="1" colspan="1">186</td><td rowspan="1" colspan="1">849,00 €</td><td rowspan="1" colspan="1">6,03 €</td><td rowspan="1" colspan="1">0,52 €</td></tr>
                    </tfoot>
                    <tbody role="alert" aria-live="polite" aria-relevant="all"><tr class="odd"><td class=" sorting_1">01.03.2023</td><td class="">48.314</td><td class="">470</td><td class="">0,97 %</td><td class="">25</td><td class="">33</td><td class="">86</td><td class="">77</td><td class="">454,86 €</td><td class="">7,45 €</td><td class="">0,77 €</td></tr><tr class="even"><td class=" sorting_1">02.03.2023</td><td class="">47.189</td><td class="">635</td><td class="">1,35 %</td><td class="">25</td><td class="">52</td><td class="">109</td><td class="">109</td><td class="">395,80 €</td><td class="">4,63 €</td><td class="">0,34 €</td></tr></tbody></table>

            </div>

        </section>

    </main>

</template>

<script>
    export default {
        props: [
        ],
        data() {
            return {
            }
        },
        created() {
            google.charts.load('current', {'packages': ['corechart']});
            google.charts.setOnLoadCallback(drawVisualization);

            function drawVisualization() {
                // Some raw data (not necessarily accurate)
                var data = google.visualization.arrayToDataTable([
                    ['Umsatz', 'Dental Bauer', 'Dürr Dental', 'Cherrymed', '3M', 'ZWP', 'Durchschnitt'],
                    ['2023/05', 165, 938, 522, 998, 450, 614.6],
                    ['2023/06', 135, 1120, 599, 1268, 288, 682],
                    ['2023/07', 157, 1167, 587, 807, 397, 623],
                    ['2023/08', 139, 1110, 615, 968, 215, 609.4],
                    ['2023/09', 136, 691, 629, 1026, 366, 569.6]
                ]);

                var options = {
                    title: 'Umsatz nach Monat',
                    vAxis: {title: 'Umsatz'},
                    hAxis: {title: 'Monat'},
                    seriesType: 'bars',
                    series: {5: {type: 'line'}}
                };

                var chart = new google.visualization.ComboChart(document.getElementById('chart_div'));
                chart.draw(data, options);
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>